import { Typography, FormControl } from '@mui/material'
import { useElements, CardElement } from '@stripe/react-stripe-js'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Box } from '@mui/material'

const cardElementOptions = {
  style: {
    base: {
      fontFamily: "Poppins",
      fontWeight: 100,
      fontSize: '14px',
      color: '#25245F',
      '::placeholder': {
        fontSize: '14px',
        color: '#D3D3DF',
      },
    },
    invalid: {},
    complete: {},
  },
  hidePostalCode: true,
}

const sx = {
  root: {},
  cardField: {
    height:'50px',
    padding: '14px 8px',
    borderRadius: '5px',
    border: '1px solid rgba(211, 211, 223, 1)',
    backgroundColor: props => (props.error ? '#fe43340d' : ''),
    borderColor: props => (props.error ? '#D14343' : ''),
  },
  '&:hover': {
    borderColor: '1px solid rgba(10, 120, 205, 1)'
  },
  test: {
    color: 'red'
  },
}

const labelStyle ={
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  color: '#D14343',
  lineHeight: '16px'
}


const CardField = ({ disabled, onComplete, customLabelStyle, required }) => {
  const [error, setError] = useState('')
  const [complete, setComplete] = useState(false)
  const elements = useElements()
  const [cardElementReady, setCardElementReady] = useState(false)
  const fieldDisabled = disabled || !cardElementReady
  const cardElementOptionsMerged = useMemo(() => ({ ...cardElementOptions, disabled }), [disabled])

  const onLabelClick = useCallback(() => {
    if (elements) {
      const cardElement = elements.getElement(CardElement)
      if (cardElement) {
        cardElement.focus()
      }
    }
  }, [elements])

  const onCardElementReady = useCallback(() => {
    setCardElementReady(true)
  }, [])

  const onChange = useCallback(event => {
    if (event.error) {
      setError(event.error.message)
    } else {
      setError('')
    }
    setComplete(event.complete)
  }, [])

  const onBlur = useCallback(() => {
    if (!complete && !error) {
      setError('Card info is not complete')
    }
  }, [complete, error])

  useEffect(() => {
    if (elements) {
      const cardElement = elements.getElement(CardElement)
      if (cardElement) {
        if (!error && complete) {
          onComplete(cardElement)
        } else {
          onComplete(null)
        }
      }
    }

  }, [complete, elements, error, onComplete])

  return (
    <FormControl disabled={fieldDisabled} fullWidth style={{ marginTop: 12 }}>
      <Typography shrink onClick={onLabelClick} style={customLabelStyle ? customLabelStyle : {}}
        component={'label'}
        color={'primary'}
        sx={{
          marginBottom: '4px',
          fontSize: '14px',
          lineHeight: '21px',
          fontWeight: 500,
        }}
      >
        Card{required ? <span className='text-danger'>&nbsp;*</span> : null}
      </Typography>


      <Box sx={sx.cardField}>
        <CardElement
          style={sx.test}
          options={cardElementOptionsMerged}
          onChange={onChange}
          onBlur={onBlur}
          onReady={onCardElementReady}
        />
      </Box>
      {!disabled && (
        <label style={labelStyle}>{error}</label>
      )}
    </FormControl>
  )
}

export default CardField
